import { Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useCurrentModal, useModal } from 'components/modal';
import { ImageRenderer } from 'components/renderField/image';
import React, { useState } from 'react';
import { DockItem, updateDockItem } from 'utils/dashboard';

function ImagePickerModal(props: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { value, onChange } = props;
  const modalCtx = useCurrentModal();

  const fakeField = {
    name: 'icon',
    schema: {
      type: 'image' as const,
      required: false,
    },
  };

  return (
    <Stack gap={2} pt={1}>
      <ImageRenderer
        field={fakeField as any}
        value={value}
        editable={true}
        onChange={async (newValue) => {
          onChange(newValue as string);
          modalCtx?.closeModal();
        }}
        viewType="card"
      />
    </Stack>
  );
}

export function DockItemEditor(props: { item: DockItem }) {
  const { item } = props;
  const modalCtx = useCurrentModal();
  const { showModal } = useModal();

  const [name, setName] = useState(item.name);
  const [iconValue, setIconValue] = useState(item.icon || '');
  const [urlValue, setUrlValue] = useState(item.type === 'url' ? item.url : '');

  const handleOpenImagePicker = () => {
    showModal(
      'Choose Icon/Image',
      <ImagePickerModal
        value={iconValue}
        onChange={(newValue) => setIconValue(newValue)}
      />,
    );
  };

  const handleSave = () => {
    if (item.type === 'url') {
      updateDockItem(item, {
        name,
        icon: iconValue || undefined,
        url: urlValue,
      });
    } else {
      updateDockItem(item, {
        name,
        icon: iconValue || undefined,
      });
    }

    modalCtx?.closeModal();
  };

  return (
    <Stack gap={3} pt={1}>
      <TextField
        fullWidth
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        variant="outlined"
      />

      {item.type === 'url' && (
        <>
          <TextField
            fullWidth
            label="URL"
            value={urlValue}
            onChange={(e) => setUrlValue(e.target.value)}
            variant="outlined"
            helperText="Enter the full URL (e.g., https://example.com or /workspace/123)"
          />
        </>
      )}

      <Divider />

      <Typography variant="h6">Icon/Image</Typography>

      <Stack spacing={2}>
        {iconValue && (
          <Box display="flex" justifyContent="center" p={2}>
            <ImageRenderer
              field={{} as any}
              value={iconValue}
              viewType="list"
            />
          </Box>
        )}

        <Button
          variant="outlined"
          onClick={handleOpenImagePicker}
          startIcon={<Edit />}
        >
          {iconValue ? 'Change Icon/Image' : 'Choose Icon/Image'}
        </Button>
      </Stack>

      <Divider />

      <Stack direction="row" gap={1}>
        <Button fullWidth color="error" onClick={() => modalCtx?.closeModal()}>
          Cancel
        </Button>
        <Button fullWidth variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
}
